export const isValidForm = (errorsObj) => Object.keys(errorsObj).length === 0;

export const buildPayload = (formData, checkType = "Enhanced") => ({
  ...formData,
  submittedAt: new Date().toISOString(),
  checkType,
});









